import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { computed, ref } from "vue";

interface RmpInformationMenuProps {
	top?: boolean;
	left?: boolean;
	right?: boolean;
	bottom?: boolean;
	text?: string;
	minWidth?: number | string;
	offsetBottom?: boolean;
	nudge?: number | string;
	hoverable?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpInformationMenu',
  props: {
    top: { type: Boolean, default: true },
    left: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false },
    text: null,
    minWidth: null,
    offsetBottom: { type: Boolean, default: false },
    nudge: { default: 6 },
    hoverable: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { top: boolean, left: boolean, right: boolean, bottom: boolean, text?: string, minWidth?: number | string, offsetBottom: boolean, nudge: number | string, hoverable: boolean };

const { colors } = useColors();



const isHovered = ref<boolean>(false);

const iconColor = computed(() => {
	return !isHovered.value ? colors.primary.base : colors.secondary.base;
});

return { __sfc: true,colors, props, isHovered, iconColor, RmpText }
}

})